import { isEmpty } from 'lodash';

const formErrorClassName = 'formError';

type FormErrorProps = {
  className: string;
  error: string | null | undefined;
  position?: ScrollLogicalPosition;
};

export const FormError = (props: FormErrorProps) => {
  if (props.error) {
    return (
      <div className={`${props.className} ${formErrorClassName}`} data-position={props.position}>
        {props.error}
      </div>
    );
  } else {
    return <></>;
  }
};

//スクロール先の要素。エラーなら表示するように実装する
type FormErrorScrollTargetProps = {
  error: string | null | undefined;
  position?: ScrollLogicalPosition;
};

export const FormErrorScrollTarget = (props: FormErrorScrollTargetProps) => {
  if (props.error) {
    return <div className={`${formErrorClassName}`} data-position={props.position}></div>;
  } else {
    return <></>;
  }
};

//スクロールの実装。エラーになっている要素に一番上にスクロール。useEffectでformikのエラーあれば使う感じ
export const formErrorScroll = () => {
  const formErrorElem = document.getElementsByClassName(formErrorClassName);
  elemScroll(formErrorElem);
};

const elemScroll = (formErrorElem: HTMLCollectionOf<Element>) => {
  if (isEmpty(formErrorElem)) return;
  const topError = formErrorElem[0];
  const position = topError.getAttribute('data-position');
  formErrorElem[0].scrollIntoView({ behavior: 'smooth', block: (position as ScrollLogicalPosition) || 'center' });
};
